(function () {
  function initSmallImageBanners() {
    document.querySelectorAll('[data-mtrx-smallimg-slide]').forEach(function (el) {
      if (el.swiper) return;
      var pagination = el.querySelector('.swiper-pagination');
      new Swiper(el, {
        slidesPerView: 1,
        loop: true,
        speed: 600,
        pagination: pagination ? { el: pagination, clickable: true } : false,
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmallImageBanners);
  } else {
    initSmallImageBanners();
  }
})();
